import { render, staticRenderFns } from "./CsSolicitudesInternasDetSolicitud.vue?vue&type=template&id=2d3d89bd"
import script from "./CsSolicitudesInternasDetSolicitud.vue?vue&type=script&lang=js"
export * from "./CsSolicitudesInternasDetSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports